// extracted by mini-css-extract-plugin
module.exports = {"group":"ButtonGroup_group__35E1f","button":"ButtonGroup_button__WgzB9","active":"ButtonGroup_active__uxTFu"};